import { render, staticRenderFns } from "./Family-statement-question.vue?vue&type=template&id=1818a0dd&scoped=true"
import script from "./Family-statement-question.vue?vue&type=script&lang=js"
export * from "./Family-statement-question.vue?vue&type=script&lang=js"
import style0 from "./Family-statement-question.vue?vue&type=style&index=0&id=1818a0dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818a0dd",
  null
  
)

export default component.exports